import { isGamiclub } from "./isGamiclub";

const domainConfig = {
    'asiacell': {
        country: 'iq',
        lang: 'ar',
        countryCode: '964'
    },
    'kz': {
        country: 'kz',
        lang: 'kk',
        countryCode: '7'
    },
    'orange': {
        country: 'ci',
        lang: 'fr',
        countryCode: '225'
    },
    'ci': {
        country: 'ci',
        lang: 'fr',
        countryCode: '225'
    },
    'cd': {
        country: 'cd',
        lang: 'fr',
        countryCode: '243'
    },
    'tn': {
        country: 'tn',
        lang: 'fr',
        countryCode: '216'
    },
    'sn': {
        country: 'sn',
        lang: 'fr',
        countryCode: '221'
    },
    'se': {
        country: 'se',
        lang: 'sv',
        countryCode: '46'
    },
    'cm': {
        country: 'cm',
        lang: 'fr',
        countryCode: '237'
    },
    'bf': {
        country: 'bf',
        lang: 'fr',
        countryCode: '226'
    },
    'nl': {
        country: 'nl',
        lang: 'be',
        countryCode: '31'
    },
    'be': {
        country: 'be',
        lang: (window.navigator.language && window.navigator.language.split('-')[0] == 'fr') ? 'fr' : (window.navigator.language && window.navigator.language.split('-')[0] == 'de') ? 'de' : 'be',
        countryCode: '32'
    },
    'no': {
        country: 'no',
        lang: 'no',
        countryCode: '47'
    },
    'kw': {
        country: 'kw',
        lang: 'en',
        countryCode: '965'
    },
    'ae': {
        country: 'ae',
        lang: 'en',
        countryCode: '971'
    },
    'bh': {
        country: 'bh',
        lang: 'en',
        countryCode: '973'
    },
    'za': {
        country: 'za',
        lang: 'en',
        countryCode: '27'
    },
    'dz': {
        country: 'dz',
        lang: 'fr',
        countryCode: '27'
    },
    'vn': {
        country: 'vn',
        lang: 'vi',
        countryCode: '84'
    },
    'eg': {
        country: 'eg',
        lang: isGamiclub ? 'en' : 'ar',
        countryCode: '20'
    },
    'my': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'tr': {
        country: 'tr',
        lang: 'tr',
        countryCode: '90'
    },
    'mase': {
        country: 'se',
        lang: 'sv',
        countryCode: '46'
    },
    'es': {
        country: 'es',
        lang: 'es',
        countryCode: '34'
    },
    'es2': {
        country: 'es',
        lang: 'es',
        countryCode: '34'
    },
    'th': {
        country: 'th',
        lang: window.location.hostname === 'th.gamezorix.com' ? 'th' : 'en',
        countryCode: '66'
    },
    'it': {
        country: 'it',
        lang: 'it',
        countryCode: '39'
    },
    'ru': {
        country: 'ru',
        lang: 'kk',
        countryCode: '7'
    },
    'hua': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'gmn': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'play': {
        country: 'my',
        lang: 'en',
        countryCode: ''
    },
    'pe': {
        country: 'pe',
        lang: 'es',
        countryCode: '51'
    },
    'pe-staging': {
        country: 'pe',
        lang: 'es',
        countryCode: '51'
    },
    'demo': {
        country: 'xx',
        lang: 'en',
        countryCode: ''
    },
    'iq': {
        country: 'iq',
        lang: isGamiclub ? 'en' : 'ar',
        countryCode: '964'
    },
    'idsale': {
        country: 'id',
        lang: 'en',
        countryCode: '62'
    },
    'id': {
        country: 'id',
        lang: 'en',
        countryCode: '62'
    },
    'pk': {
        country: 'pk',
        lang: 'en',
        countryCode: '62'
    },
    'sa': {
        country: 'sa',
        lang: 'en',
        countryCode: '966'
    },
    'maxis': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'gh':{
        country: 'gh',
        lang: 'en',
        countryCode: '233'
    },
    'gr': {
        country: 'gr',
        lang: 'el',
        countryCode: '30'
    },
    'ke':{
        country: 'ke',
        lang: 'en',
        countryCode: '254'
    },
    'qa':{
        country: 'qa',
        lang: 'en',
        countryCode: '974'
    },
    'rs':{
        country: 'rs',
        lang: 'cy',
        countryCode: '381'
    },
    'ch':{
        country: 'ch',
        lang: (window.navigator.language && window.navigator.language.split('-')[0] == 'fr') ? 'fr' : 'de',
        countryCode: '41'
    },
    'ro': {
        country: 'ro',
        lang: 'ro',
        countryCode: '40'
    },
    'rsma': {
        country: 'rs',
        lang: 'en',
        countryCode: '381'
    },
    'cz': {
        country: 'cz',
        lang: 'cs',
        countryCode: '420'
    },
    'maae': {
        country: 'ae',
        lang: 'en',
        countryCode: '971'
    },
    'uk': {
        country: 'gb',
        lang: 'en',
        countryCode: '44'
    },
    'pt': {
        country: 'pt',
        lang: 'pt',
        countryCode: '351'
    },
    'lt': {
        country: 'lt',
        lang: 'lt',
        countryCode: '370'
    },
    'si': {
        country: 'si',
        lang: 'si',
        countryCode: '386'
    },
    'fr': {
        country: 'fr',
        lang: 'fr',
        countryCode: '33'
    },
    'pl': {
        country: 'pl',
        lang: 'pl',
        countryCode: '48'
    },
    'portal': {
        country: 'lt',
        lang: 'lt',
        countryCode: '370'
    },
    'bg': {
        country: 'bg',
        lang: 'bg',
        countryCode: '+359'
    }
}
const defaultConfig = {
    country: 'xx',
    lang: 'en',
    countryCode: ''
}

export let config = {};

const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return parts[0];
}

const getConfigsForSubdomain = (subdomain) => {
    let configForSubDomain = domainConfig[subdomain] || defaultConfig;
    configForSubDomain.subDomain = subdomain;
    return configForSubDomain;
}

if (getSubdomain() == 'localhost') config = getConfigsForSubdomain('th'); //pass the subDomain to getConfigsForSubdomain which you want to simulate on localhost
else config = getConfigsForSubdomain(getSubdomain());
console.log(config);





// WEBPACK FOOTER //
// ./src/constants/domainConfig.js